import { useLayoutEffect, useState } from 'react';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../../tailwind.config';

const breakpoints = resolveConfig(tailwindConfig).theme.screens;
export const useBreakpoint = (breakpoint: keyof typeof breakpoints) => {
  const [mobile, setMobile] = useState(false);

  useLayoutEffect(() => {
    const handleResize = () => {
      const breakpointWidth = Number(breakpoints[breakpoint].replace('px', ''));
      if (window.innerWidth < breakpointWidth) {
        setMobile(true);
        return;
      }
      setMobile(false);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return mobile;
};
